import { fetchWithAuth, getCSRFToken } from "../auth"

export async function searchAssets(query = '', params = {}) {
    const urlParams = new URLSearchParams({ pageSize: 20 })
    if (query) urlParams.set('search', query)
    Object.entries(params).forEach(([key, value]) => {
        if (value != null) urlParams.set(key, value)
    })
    const resp = await fetchWithAuth(
        `${process.env.REACT_APP_ICC_TOOL_API_HOST}assets/?${urlParams}`,
        { headers: { 'X-CSRFToken': getCSRFToken() }, credentials: 'include' }
    )
    const respJson = await resp.json()
    const raw = respJson.results ?? respJson
    return Array.isArray(raw) ? raw : []
}

export async function getTeamAssets(teamId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/' + teamId + "/assets/", {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getMemberAssets(userId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/' + userId + "/assets/", {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getAsset(assetId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'assets/' + assetId + '/')
    const respJson = await resp.json()
    return respJson
}

export async function getMemberDetails(memberId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/' + memberId + '/')
    const respJson = await resp.json()
    return respJson
}

export async function getTeams() {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getTeamDetails(id) {
    const response = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `teams/${id}/`, {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    });
    const data = await response.json();
    return data
}

export async function getTeamReadinessReport(id) {
    const response = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `readiness/?readiness_id=` + id, {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    });
    const data = await response.json();
    return data
}

export async function getPreviousReadiness(teamId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `readiness?team=${teamId}&count=1`, {
        headers: {
            'X-CSRFToken': getCSRFToken()
        }
    })
    const respJson = await resp.json()
    return respJson
}

export async function getUnresolvedProblems(assetId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `assets/${assetId}/problems?resolved=false`, {
        headers: {
            'X-CSRFToken': getCSRFToken()
        }
    })
    const respJson = await resp.json()
    return respJson
}

export async function getApprovedEvents(memberId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/' + memberId + '/schedule/?approval_status=approved', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getSchedule(memberId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/' + memberId + '/schedule/', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    return resp
}

export async function getScheduleCurrent(memberId) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/' + memberId + '/schedule?only_current=true', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getAllMembers() {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    const respJson = await resp.json()
    return respJson
}

export async function getMemberIds(id) {
    const respJson = await getTeamDetails(id)
    return respJson['members'].map((member) => {
        return member.userId
    })
}

export async function getTeamSchedule(id) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + '/events/?team=' + id, {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    return resp
}

export async function getTeamEventSchedule(id) {
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + '/teamevents/' + id + '/schedule/', {
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    })
    return resp
}
